<template>
  <div class="c-app-content">
    <div class="c-app-title">
      <div>
        <h1>
          <img class="c-app-title__icon" src="../../assets/images/icons/icon24-opportunities-primary.svg" alt="opportunities"> {{$t('report')}}
        </h1>
      </div>
      <ul class="c-app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Callio</router-link></li>
        <li class="breadcrumb-item"><router-link to="/report">{{ $t('reports') }}</router-link></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="tile">
          <div class="c-action">
            <div class="row">
              <div class="col-lg-4 c-action__left"><span class="c-action__count">{{ $t('summary') }}</span></div>
              <div class="col-lg-8 c-action__right">
                <time-range-picker :model="filterModel" :label="$t('time')" @change="load" :defaultShortcut="0">
                </time-range-picker>
                <button class="btn btn-sm btn-primary" @click="load"><i class="fa fa-refresh mr-0"></i></button>
              </div>
            </div>
          </div>
          <div class="tile-body">
            <div class="col" v-if="firstLoading">
              <skeleton-loading>
                <row>
                  <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
                </row>
                <row>
                  <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
                </row>
              </skeleton-loading>
            </div>
            <div v-else class="c-report-grid">
              <ul>
                <li>
                  <div class="c-report-item">
                    <router-link to="/report/call">
                      <figure class="c-report-item__img"><img
                          src="../../assets/images/icons/icon32-phone-volume-primary.svg"
                          :alt="$t('calls')">
                      </figure>
                      <span class="c-report-item__count" id="callCountData">
                        <b-spinner v-if="loading" small></b-spinner>
                        <span v-else-if="data.callCount">{{ data.callCount }}</span>
                        <span v-else>0</span>
                      </span>
                      <span class="c-report-item__title">{{ $t('calls') }}</span>
                    </router-link>
                  </div>
                </li>
                <li>
                  <div class="c-report-item">
                    <router-link to="/report/audio-quality">
                      <figure class="c-report-item__img"><img
                          src="../../assets/images/icons/icon32-quality.svg"
                          :alt="$t('callQuality')">
                      </figure>
                      <span class="c-report-item__count" id="customerLogCountData">
                        <b-spinner v-if="loading" small></b-spinner>
                        <span v-else-if="data.avgCallQuality">{{ callQuality }}</span>
                        <span v-else>0</span>%
                      </span>
                      <span class="c-report-item__title">{{ $t('callQuality') }}</span>
                    </router-link>
                  </div>
                </li>
                <li v-if="['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes($store.state.user.role)">
                  <div class="c-report-item" v-b-tooltip="'Số bệnh nhân đã liên hệ'">
                    <router-link to="/report/patient">
                      <figure class="c-report-item__img"><img
                          src="../../assets/images/icons/icon32-opportunities-primary.svg"
                          :alt="$t('patient')">
                      </figure>
                      <span class="c-report-item__count" id="customerLogCountData">
                        <b-spinner v-if="loading" small></b-spinner>
                        <span v-else-if="data.patientCount">{{data.patientCount}}</span>
                        <span v-else>0</span>
                      </span>
                      <span class="c-report-item__title">{{ $t('patient') }}</span>
                    </router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="$store.state.user.permissions.find(p => ['reportListAll', 'reportListGroup'].includes(p))">
        <div class="tile small">
          <div class="c-leader-head">
            <span class="c-leader-head__title">{{ $t('leaderboard') }}</span>
            <div class="c-leader-head__action">
              <dropdown :model="boardModel" attribute="board" :right-menu="true"
                        type="bordered" icon="fa fa-filter" :options="[
                            {value:'call',text:$t('calls')},
                            {value:'talkTime',text:$t('talkTime')},
                            {value:'newOpportunities',text:$t('newOpportunities')},
                          ]"
                        @change="loadBoard">
              </dropdown>
            </div>
          </div>
          <div class="c-leader-table">
            <div class="col mt-3" v-if="boardLoading">
              <skeleton-loading>
                <row>
                  <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
                </row>
                <row>
                  <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
                </row>
              </skeleton-loading>
            </div>
            <table v-else class="table">
              <tbody>
              <tr :key="index" v-for="(item, index) in boardData">
                <td>{{ index + 1 }}</td>
                <td><span class="text-blue">{{ item.name }}</span></td>
                <td class="text-right">
                  <span v-if="boardModel.board === 'talkTime'">{{ item.count | callDuration}}</span>
                  <span v-else>{{ item.count}}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeRangePicker from "../../components/TimeRangePicker";
import _ from "lodash";
import Dropdown from "@/components/Dropdown";

export default {
  components: {
    Dropdown,
    TimeRangePicker
  },
  data: function () {
    return {
      loading: true,
      firstLoading: true,
      boardLoading: true,
      filterModel: {},
      boardModel: {
        board: 'call'
      },
      data: {},
      boardData: [],
    }
  },
  methods: {
    load() {
      let loadingDelay = _.delay(() => {
        this.loading = true;
      }, 250);
      this.$service.get('/report/overview', {
        params: this.filterModel
      }).then(response => {
        this.data = response.data;
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        clearTimeout(loadingDelay);
        this.loading = false;
        this.firstLoading = false;
      });
      this.loadBoard();
      // this.loadReport();
    },
    loadBoard() {
      let service;
      let attr;
      switch (this.boardModel.board) {
        case "talkTime":
          service = '/report/call';
          attr = 'billDuration';
          break;
        case "newOpportunities":
          service = '/report/opportunity';
          attr = 'new';
          break;
        default:
          service = '/report/call';
          attr = 'success';
          break;
      }

      let loadingDelay = _.delay(() => {
        this.boardLoading = true;
      }, 250);
      this.$service.get(service, {
        params: {
          from: this.filterModel.from,
          to: this.filterModel.to,
          group: 'user'
        }
      }).then(response => {
        response.data.sort(function (a, b) {return b[attr] - a[attr]}).slice(0, 9);
        this.boardData = response.data.map(i => {
          return {name: i.label, count: i[attr]}
        });
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        clearTimeout(loadingDelay);
        this.boardLoading = false;
      });
    }
  },
  computed: {
    callQuality() {
      if (this.data.avgCallQuality) {
        return Math.round(this.data.avgCallQuality);
      }
      return 0
    }
  }
}
</script>